module.exports = __webpack_public_path__ + "static/img/10022.bf32ceb4.png";